import {charcoal} from '../sass/base/_exports.sass';

export const CrownIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 28;

  // Use ratio to calculate width and height
  const style = {
    height: `${ratio * height}px`,
    width: `${ratio * width}px`,
  };

  // todo why is viewbox different than width/height?
  return (
    <svg
      viewBox="0 0 16 14"
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.98611 4.34056L2.71137 9.24273H13.3042L14.0253 4.26903L11.1201 6.78083L7.99696 2.76611L4.74576 6.76753L1.98611 4.34056ZM10.3349 3.06221L10.2701 3.11793L10.3873 3.12958L11.3579 4.37633L12.5531 3.34333L12.6696 3.35497L12.618 3.28677L14.625 1.5518C14.7532 1.44111 14.9123 1.37224 15.0808 1.35442C15.2493 1.3366 15.4192 1.37067 15.5679 1.45208C15.7165 1.53348 15.8367 1.65834 15.9124 1.80994C15.9881 1.96153 16.0157 2.13264 15.9915 2.30035L14.7439 10.9062H1.27582L0.00910656 2.33944C-0.0160553 2.1708 0.0112231 1.9985 0.0872471 1.84587C0.163271 1.69325 0.284367 1.56768 0.434133 1.48617C0.5839 1.40466 0.755099 1.37115 0.924544 1.39018C1.09399 1.40921 1.25349 1.47986 1.38145 1.59255L3.29524 3.27679L3.25365 3.32669L3.34431 3.32004L4.54532 4.37633L5.55336 3.13457L5.64402 3.12708L5.59412 3.08383L7.36652 0.905553C7.44547 0.808499 7.5453 0.730508 7.65857 0.677387C7.77185 0.624266 7.89564 0.597384 8.02075 0.598743C8.14585 0.600102 8.26904 0.629667 8.38113 0.685236C8.49322 0.740805 8.59133 0.820946 8.66816 0.919692L10.3349 3.06221ZM1.34069 11.7379H14.6482V12.5696C14.6482 12.7902 14.5606 13.0018 14.4046 13.1577C14.2487 13.3137 14.0371 13.4013 13.8165 13.4013H2.17241C1.95183 13.4013 1.74028 13.3137 1.5843 13.1577C1.42832 13.0018 1.34069 12.7902 1.34069 12.5696V11.7379Z"
        fill={color}
      />
    </svg>
  );
};
